import { motionDuration, motionEasing } from "@maeiz/tokens";
import { DocPage, Section, SpecTable, DoDont } from "../../components/DocChrome";

export function MotionPage() {
    return (
        <DocPage
            title="Motion & Animation"
            description="Restrained Workspace motion. Buttons and cards have zero motion."
        >
            <Section title="Hard rules (Hallmark modern-minimal)">
                <ul className="list-disc space-y-1 ps-5">
                    <li>
                        <strong>Buttons:</strong> no scale, no lift, no Framer — color/border only.
                    </li>
                    <li>
                        <strong>Cards:</strong> no hover translate or scale.
                    </li>
                    <li>
                        Animate only <code>transform</code> + <code>opacity</code> on
                        overlays/toasts when needed.
                    </li>
                    <li>
                        Honor <code>prefers-reduced-motion</code> (token durations collapse to 0).
                    </li>
                </ul>
            </Section>
            <Section title="Duration tokens (overlays)">
                <SpecTable
                    rows={[
                        ...Object.entries(motionDuration).map(
                            ([k, v]) => [k, v] as [string, string]
                        ),
                        ["--mz-ease-out", "cubic-bezier(0.16, 1, 0.3, 1)"],
                        ["--mz-dur-short", "220ms — menu/tooltip"],
                        ["--mz-dur-long", "420ms — modal/drawer"],
                    ]}
                />
            </Section>
            <Section title="Easing">
                <SpecTable rows={Object.entries(motionEasing).map(([k, v]) => [k, v])} />
            </Section>
            <DoDont
                doItems={[
                    "Opacity crossfade on tooltip",
                    "Instant focus rings",
                    "Still buttons and cards",
                ]}
                dontItems={[
                    "whileHover scale on Button",
                    "Card hover:-translate-y",
                    "Bounce / spring UI state",
                ]}
            />
        </DocPage>
    );
}
